"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _underscore = _interopRequireDefault(require("underscore"));

var _LogoImage = _interopRequireDefault(require("../LogoImage/LogoImage"));

require("./MemberBanner.less");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var MemberBanner = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(MemberBanner, _React$Component);

  var _super = _createSuper(MemberBanner);

  function MemberBanner(props) {
    (0, _classCallCheck2.default)(this, MemberBanner);
    return _super.call(this, props);
  }

  (0, _createClass2.default)(MemberBanner, [{
    key: "getBannerText",
    value: function getBannerText() {
      if (this.props.bannerText) {
        return /*#__PURE__*/_react.default.createElement("p", {
          className: "banner-text",
          dangerouslySetInnerHTML: this.escapeHtml(this.props.bannerText)
        });
      }

      return null;
    }
  }, {
    key: "escapeHtml",
    value: function escapeHtml(text) {
      return {
        __html: text
      };
    }
  }, {
    key: "renderAddress",
    value: function renderAddress() {
      var state = this.props.member.address.state ? this.props.member.address.state : this.props.member.address.zoneName;
      var country = this.props.member.address.country ? this.props.member.address.country : this.props.member.address.countryName;
      var zipCode = this.props.member.address.zipCode ? this.props.member.address.zipCode : this.props.member.address.postCode;
      var address = this.props.member.address;

      var displayAddress = _underscore.default.filter([address.address1, address.address2, address.city, state, zipCode, country], function (val) {
        return val && val !== '';
      }).join(', ');

      return /*#__PURE__*/_react.default.createElement("p", {
        className: "issuer-address",
        dangerouslySetInnerHTML: this.escapeHtml(displayAddress)
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "member-banner"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "left-item"
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "issuer-logo-wrapper"
      }, /*#__PURE__*/_react.default.createElement(_LogoImage.default, {
        member: this.props.member,
        imageBaseUrl: this.props.imageBaseUrl
      })), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
        className: "container-fluid"
      }, this.getBannerText(), /*#__PURE__*/_react.default.createElement("p", {
        className: "issuer-name",
        dangerouslySetInnerHTML: this.escapeHtml(this.props.member.name)
      }), this.renderAddress())));
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        member: _propTypes.default.shape({
          id: _propTypes.default.number.isRequired,
          name: _propTypes.default.string.isRequired,
          address: _propTypes.default.shape({
            address1: _propTypes.default.string,
            city: _propTypes.default.string.isRequired,
            state: _propTypes.default.string,
            zoneName: _propTypes.default.string,
            zipCode: _propTypes.default.string,
            postCode: _propTypes.default.string,
            country: _propTypes.default.string,
            countryName: _propTypes.default.string
          }).isRequired
        }),
        bannerText: _propTypes.default.string,
        imageBaseUrl: _propTypes.default.string
      };
    }
  }, {
    key: "defaultProps",
    get: function get() {
      return {
        bannerText: 'Ordering From'
      };
    }
  }]);
  return MemberBanner;
}(_react.default.Component);

exports.default = MemberBanner;